import "./Page.scss"

import { FC, ReactNode } from "react"

import Header from "components/Header/Header"

type PageTheme = "default" | "light"
type PageContentType = "default" | "wizard"
type PageContentWidth = "full" | "wide"

interface IPageProps {
    header?: ReactNode
    footer?: ReactNode
    toolbar?: ReactNode
    theme?: PageTheme
    contentType?: PageContentType
    padding?: string
    contentWidth?: PageContentWidth
    minWidth?: string
    fullHeight?: boolean
}

const Page: FC<React.PropsWithChildren<IPageProps>> = ({
    header = <Header />,
    footer,
    toolbar,
    theme = "default",
    contentType = "default",
    padding,
    contentWidth = "full",
    minWidth = "auto",
    fullHeight = false,
    children,
}) => {
    return (
        <div className={"page page--theme-" + theme + " page--content-type-" + contentType} style={{ minWidth }}>
            {header &&
                <div className="page__header">
                    {header}
                </div>
            }
            {toolbar &&
                <div className="page__toolbar">
                    {toolbar}
                </div>
            }
            <div className={`page__body ${fullHeight ? 'page__body--full-height' : ''}`} style={{ padding }}>
                <div className={`page__content page__content--width-${contentWidth}`}>
                    {children}
                </div>
            </div>
            {footer &&
                <div className="page__footer">
                    {footer}
                </div>
            }
        </div>
    )
}

export default Page
